import Share from '@carvana/icons/Share';
import { createComponent } from '@carvana/merch-components';
import { TertiaryButton } from '@/common/Button';
import CtaButton from '@/vdp/CtaButton';
import styles from './HeroHeaderLite.module.css';

export const Wrapper = createComponent('div', {
  className: `${styles.wrapper} pointer-events-none relative grid justify-between gap-8`
});

export const FirstRow = createComponent('div', {
  className: `${styles['first-row']} flex items-center justify-between`
});

export const Actions = createComponent('div', {
  className: `flex justify-end m:gap-16`
});

export const ActionButton = createComponent('div', {
  className: 'flex min-w-[25px] items-center justify-end'
});

export const ShareButton = createComponent(Share, {
  className: `${styles['share-button']} pointer-events-auto flex fill-blue-6`
});

export const VehicleDescription = createComponent('div', {
  className: `${styles['vehicle-description']} grid h-fit gap-y-4`
});

export const YearMakeModel = createComponent('p', {
  className: `${styles['year-make-model']} font-bold text-blue-6`
});

export const TrimMileageBadge = createComponent('div', {
  className:
    'grid w-fit gap-x-8 text-blue-7 tl-body-s m:grid-flow-col m:tl-body-m'
});

export const PriceAndButtons = createComponent('div', {
  className: `${styles['price-and-buttons']} grid grid-flow-col items-center gap-x-24`
});

export const GetStarted = createComponent(CtaButton, {
  className: `${styles.button} pointer-events-auto`
});

export const ViewMore = createComponent(TertiaryButton, {
  className: `${styles.button} pointer-events-auto m-0 border border-solid border-current bg-white`
});
